// This file is now a simple re-export of the platform-specific implementation
export * from './uploaderService/'; 